import { render, staticRenderFns } from "./LaboratoryCCDataTable.vue?vue&type=template&id=e89c7be2"
import script from "./LaboratoryCCDataTable.vue?vue&type=script&lang=js"
export * from "./LaboratoryCCDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports